import { Model } from "./Model";
import { VisitorType } from "../enums/Index";

export interface Visitor extends Model {
	accessCode: string;
	companyName: string;
	emailAddress: string;
	name: string;
	photoUrl: string;
	telephoneNumber: string;
	userId: number | null;
	vehicleRegistration: string;
	visitorType: VisitorType;
}

export class Visitor implements Visitor {
	constructor(data?: Partial<Visitor>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}